import type { EnlaceService } from './types'

export const enlaceMock: EnlaceService = {
  async resend() {
    await new Promise((r) => setTimeout(r, 400))
  },
}
